import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {ListItem} from "../../../objects/listItem";
import {User} from "../../../objects/user";
import {FormControl, FormGroup} from "@angular/forms";
import {environment} from "../../../../environments/environment";
import {FS3Notification} from "../../../objects/notification";
import {AppEvent} from "../../../objects/appEvent";
import {SubscriptionLike} from "rxjs";
import {SharedDataService} from "../../../services/shared-data.service";

@Component({
  selector: 'app-cup-game-popup',
  templateUrl: './cup-game-popup.component.html',
  styleUrls: ['./cup-game-popup.component.css']
})
export class CupGamePopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<object>();

  listItem:ListItem;
  gamePayload:object;
  state = 'default'
  mode = 'default'  //edit_game/loading/default
  errMsg = ''
  allowEditMode = false
  allowEventDelete = false
  allowFullView = false
  profileLeft:User = new User()
  profileRight:User = new User()
  public componentForm: FormGroup = new FormGroup({});
  public scoreLeft: FormControl = new FormControl(1);
  public scoreRight: FormControl = new FormControl(1);

  constructor() { }

  ngOnInit(): void {
    this.componentForm.addControl('scoreLeft', this.scoreLeft);
    this.componentForm.addControl('scoreRight', this.scoreRight);
    this.listItem = this.payload['item'];
    this.gamePayload = this.listItem['itemFullData']['payload_parsed'];

    this.profileLeft = this.gamePayload['profiles'][0];
    this.profileRight = this.gamePayload['profiles'][1];
    if (['pending', 'score_confirmation'].includes(this.gamePayload['status'])) {
      this.mode = 'edit_game';
      if (this.gamePayload['score']) {
        let sroreParts = this.gamePayload['score'].split(':')
        this.scoreLeft.setValue(sroreParts[0])
        this.scoreRight.setValue(sroreParts[1])
      } else {
        this.scoreLeft.setValue(3)
        this.scoreRight.setValue(0)
      }
    }
  }

  public saveGame(): void {
    let scoreLeft = parseInt(this.scoreLeft.value);
    let scoreRight = parseInt(this.scoreRight.value);
    if(scoreLeft == scoreRight) {
      this.errMsg = 'game resul cant be equal';
      return;
    }
    this.success.emit({"score": scoreLeft+':'+scoreRight})
  }

  public onNoClick(): void {
    this.close.emit()
  }

}
